module.exports = __webpack_public_path__ + "assets/images/magenta_sport_start.90753dbc466916982177290688656069.png";